import { Error } from './Error';

export class ValidationResult {
	referencePackageSizeIsMissing: boolean;

	productErrors: Error[];

	countryErrors: Error[];

	constructor(referencePackageSizeIsMissing: boolean, productErrors: Error[], countryErrors: Error[]) {
		this.referencePackageSizeIsMissing = referencePackageSizeIsMissing;
		this.productErrors = productErrors;
		this.countryErrors = countryErrors;
	}
}
